module.exports = __webpack_public_path__ + "img/diet.afdb6ec5.png";